import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Col, Grid, Row } from "react-bootstrap";
import "./audio-management.scss";
import { If } from "react-extras";
import MarkersChooseEpisodeModal from "./markers_choose_modal";
import { getMarkersPage } from "../../../action_managers/audio_management";
import PageWrapper from "../../lib/page-wrapper";
import MarkersTable from "./markers_table";
import ExternalLink from "../../lib/external_link";

const MarkersPage = props => {
  const [showModal, changeShowModal] = useState(false);
  const dispatch = useDispatch();

  const markersPageUUIDs = useSelector(state => state.markers.markersPageUUIDs);
  const markerByUUID = useSelector(state => state.markers.markers);
  const markers = markersPageUUIDs.map(uuid => markerByUUID[uuid]);
  const isLoading = useSelector(state => state.markers.isLoading);

  useEffect(() => {
    dispatch(getMarkersPage());
  }, [dispatch]);

  return (
    <PageWrapper
      backLink={"/dynamic-insertion"}
      title={"Insertion Points"}
      dividerMarginBottom={"0px"}
      topRightElement={() => (
        <button onClick={() => changeShowModal(true)} className="fake-link">
          New Insertion Point
        </button>
      )}>
      <Grid fluid>
        <If condition={!markers.length && !isLoading}>
          <RenderEmptyState showModal={() => changeShowModal(true)} />
        </If>
        <If condition={markers.length && !isLoading}>
          <MarkersTable markers={markers} />
        </If>
        <If condition={showModal}>
          <MarkersChooseEpisodeModal hideModal={() => changeShowModal(false)} />
        </If>
      </Grid>
    </PageWrapper>
  );
};

export default MarkersPage;

const RenderEmptyState = ({ showModal }) => {
  return (
    <div className="markers">
      <Grid fluid>
        <Row className="audio-management-page__empty-state-container">
          <Col xs={8} xsOffset={2}>
            <div>
              None of your episodes have insertion points yet. Insertion points allow you to choose
              places that RedCircle can insert content into your podcast episode. You can manage
              your content yourself, or let RedCircle do it for you.
            </div>
            <div>
              <ExternalLink
                href={"https://support.redcircle.com/en/articles/3456198-insertion-points"}
                className="bold">
                Learn More
              </ExternalLink>
            </div>
          </Col>
          <Col xs={4} xsOffset={4}>
            <Button
              onClick={showModal}
              className="btn btn-primary audio-management__new-entity-btn">
              New Insertion Point
            </Button>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};
